import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;

export class DashboardService {
    constructor() {
    }
    getServices() {
        // let serviceList = {
        //     "response": [
        //         {
        //             "text": "Contractor Labour",
        //             "value": "Contractor Labour"
        //         },
        //         {
        //             "text": "Contractor Specialised",
        //             "value": "Contractor Specialised"
        //         },
        //         {
        //             "text": "Contractor Equipment Hiring",
        //             "value": "Contractor Equipment Hiring"
        //         },
        //         {
        //             "text": "Contractor Professional Services",
        //             "value": "Contractor Professional Services"
        //         },
        //         {
        //             "text": "Contractor Transportation services",
        //             "value": "Contractor Transportation services"
        //         }
        //     ]
        // }
        // return serviceList;
    }
    copyData(postData) {;
        const uri = `/api/partner/info/category`
        return apiHelper.post(uri,postData);
    }
    deleteAccountConfirm(pid,categoryCode){
        const uri = `/api/common-view/delete/duplicatePartner/${pid}/categoryCode/${categoryCode}`
        return apiHelper.post(uri,{});
    }
    updateCompanyName(name){
        const uri = `/api/common-view/partner/updateCompanyName/${name}`
        return apiHelper.get(uri);        
    }
    getPartnerDetails() {
        const uri = `/api/partner/info`
        return apiHelper.get(uri);
    }
    getPartnerCompanies(pid) {
        const uri = `/api/companyMapping/partnerCompanies` 
        return apiHelper.get(uri);
    }
    getCompanyNavigation(companyCode){
        const uri = `/api/companyMapping/companyNavigation/companyCode/${companyCode}` 
        return apiHelper.get(uri);
    }
    getSSCNotification(id){
        const uri = `/api/notification/scroll-message/${id}` 
        return apiHelper.get(uri);
    }    
    getPartnertype(code) {
        const uri = `/api/partner/partner-type/company-code/${code}`
        return apiHelper.get(uri)
    }
    getProfileDetails(categoryCode, companyCode) {
        const uri = `/api/user-category-audit/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.post(uri)
    }
    getProgressDetails(categoryCode, companyCode, isInternational) {
        const uri = `/api/onboard-questions/category-code/${categoryCode}/company-code/${companyCode}/isInternational/${isInternational}`
        return apiHelper.get(uri);
    }
    getBusinessTypeStatus(categoryCode, companyCode) {
        const uri = `/api/partner-business-types/category/${categoryCode}/company-code/${companyCode}`
        return apiHelper.get(uri);
    }
    getBusinessTypes(companyCode, categoryCode) {
        const uri = `/api/business-type/company/${companyCode}/category/${categoryCode}`
        return apiHelper.get(uri);
    }
    getMigrationStatus(companyCode, categoryCode, partnerId) {
        const uri = `/api/migration-status/company/${companyCode}/category/${categoryCode}/partner/${partnerId}`
        return apiHelper.get(uri);
    }
    getBussiness(companyCode) {
        const uri = `/api/business-category/primary-business/company-code?companyCode=${companyCode}`;
        return apiHelper.get(uri);
    }
    sendBusinessType(businessDetails) {
        const uri = `/api/partner-business-types`
        return apiHelper.post(uri, businessDetails)
    }
    getPrimaryCategoryList(categoryCode) {
        const uri = `/api/business-category/categories/category-code?categoryCode=` + categoryCode;
        return apiHelper.get(uri);
    }
    getPartnerHeader(partnerId){
        const uri = `/api/common-view/headerDetails/partnerid=` + partnerId;
        return apiHelper.get(uri);
    }
    getVideoGuides(pagename) {
        const uri = `/api/faq/getAllFaqs?pagename=` + pagename;
        return apiHelper.get(uri);        
    }
    getSubCategoryList(categories) {
        const uri = `/api/business-category/sub-categories/category-code?categoryCode=` + categories;
        return apiHelper.get(uri);
    }
    saveSecondaryBusiness(data) {
        const uri = `/api/partner-category`
        return apiHelper.post(uri, data)
    }
    saveBranchBussiness(data) {
        const uri = `/api/branch-category`
        return apiHelper.post(uri, data)
    }
    editSecondaryBusiness(data) {
        const uri = `/api/partner-categories`
        return apiHelper.put(uri, data)
    }
    editPrimaryBusiness(data) {
        const uri = `/api/partner-category/primary`
        return apiHelper.put(uri, data)
    }
    deleteSecondaryBusiness(data) {
        const uri = `/api/partner-categories/delete`
        return apiHelper.remove(uri, data)
    }
    resetBusinessType(categoryCode, companyCode) {
        const uri = `/api/partner-business-types/category/${categoryCode}/company-code/${companyCode}/reset`
        return apiHelper.remove(uri, {})
    }
    getGroupChartData(moduleName, categoryCode, companyCode) {
        const uri = `/api/onboard-questions/module/${moduleName}/category/${categoryCode}/company/${companyCode}`
        return apiHelper.get(uri)
    }
    onBoardingPreviewStatus(categoryCode, companyCode) {
        const uri = `/api/onboard-answer-head/category-code/${categoryCode}/company-code/${companyCode}/document/POB`
        return apiHelper.get(uri)
    }
    getEbid(data) {
        const uri = `/api/eip/partner/rfq`
        return apiHelper.post(uri, data)
    }

    // getEbid(companyCode, fromDate, toDate) {
    //     const uri = `/api/eip/partner/rfq-list/company-code/${companyCode}?from=${fromDate}&to=${toDate}`
    //     return apiHelper.post(uri)
    // }
    changePassword(data) {
        const uri = `/api/user/change-password`;
        return apiHelper.post(uri, data);
    }
    getEIPPartnerDetails() {
        const uri = `/api/eip/partner/detail`
        return apiHelper.get(uri);
    }
    userLogout(data) {
        // data.loginAuditNumber = ''
        const uri = `/api/useraudit/logout`
        return apiHelper.post(uri, data)
    }

    getScrollMessages(data) {
        const uri = `/api/scroll-message`;
        return apiHelper.post(uri, data);
    }
    getBranchPrimaryBussiness(companyCode, categorycode) {
        const uri = `/api/parent/partner-type/detail/company-code/${companyCode}/category-code/${categorycode}`
        return apiHelper.get(uri);
    }

    getAllCurrencies() {
        const uri = `/api/currency`;
        return apiHelper.get(uri);
    }

    getCurrencyUnitsByCurrencyCode(currencyCode) {
        const uri = `/api/currency-units/${currencyCode}`;
        return apiHelper.get(uri);
    }

    sendCurrencyTypes(data) {
        const uri = `/api/partner/currency-units/save`;
        return apiHelper.post(uri, data);
    }

}